(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("itowns_widgets", [], factory);
	else if(typeof exports === 'object')
		exports["itowns_widgets"] = factory();
	else
		root["itowns_widgets"] = factory();
})(self, () => {
return 